<template>
  <div class="debt">
    <AppBar></AppBar>
    <v-container>
      <v-row justify="center" align="center">
        <v-col class="text-right" lg="2" md="2" cols="6"
          >รายงานรายการตัดชำระหนี้ เดือน</v-col
        >
        <v-col lg="1" md="1" cols="3">
          <v-select
            :items="month_name"
            outlined
            v-model="month"
            dense
            item-text="name"
            item-value="no"
          ></v-select>
        </v-col>
        <v-col class="text-left" lg="1" md="1" cols="3"> ปี {{ year }} </v-col>
        <v-col class="text-right pt-0 pb-6" lg="1" md="1" cols="4">
          <v-btn color="primary" small block @click="getPaymentList()"
            >ค้นหา</v-btn
          >
        </v-col>
        <v-col class="text-right pt-0 pb-6" lg="1" md="1" cols="4">
          <v-btn
            v-if="false"
            color="success"
            small
            block
            :disabled="!isData"
            @click="downloadPaymentList()"
            >ดาว์นโหลด</v-btn
          >
        </v-col>
      </v-row>
      <v-row justify="center" align="center">
        <v-col lg="10" md="10" cols="12" v-if="isData" class="text-left">
          <v-sheet
            id="scrolling-techniques-6"
            class="overflow-y-auto"
            max-height="600"
          >
            <v-container>
              <v-row justify="center" align="center">
                <v-col class="text-center">
                  <v-data-table
                    :headers="headers"
                    :items="data_payments"
                    :items-per-page="500"
                  ></v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-sheet>
        </v-col>
        <v-col lg="6" md="6" cols="12" v-else class="text-center">
          <p>ไม่พบข้อมูลที่ต้องการค้นหา</p>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import AppBar from "../components/AppBar";
export default {
  name: "PayDebt",
  components: { AppBar },
  data: () => ({
    year: 0,
    month: 3,
    headers: [
      {
        text: "เลขที่เอกสาร",
        value: "DocNo",
      },
      { text: "รหัสเจ้าหนี้", value: "ApCode" },
      { text: "ชื่อเจ้าหนี้", value: "Name1" },
    ],
    isData: false,
    month_name: [
      { no: 1, name: "มกราคม" },
      { no: 2, name: "กุมภาพันธ์" },
      { no: 3, name: "มีนาคม" },
      { no: 4, name: "เมษายน" },
      { no: 5, name: "พฤษภาคม" },
      { no: 6, name: "มิถุนายน" },
      { no: 7, name: "กรกฎาคม" },
      { no: 8, name: "สิงหาคม" },
      { no: 9, name: "กันยายน" },
      { no: 10, name: "ตุลาคม" },
      { no: 11, name: "พฤศจิกายน" },
      { no: 12, name: "ธันวาคม" },
    ],
    data_payments: [],
  }),
  created() {
    let date = new Date();
    this.year = date.getFullYear();
    this.month = parseInt(date.getMonth() + 1);
  },
  methods: {
    getPaymentList() {
      let database = localStorage.getItem("hml_portal_company");
      if (database === "KMP") {
        database = "HML";
      }
      this.$axios
        .post(this.api + "/getpayment", {
          database: database,
          month: this.month,
          year: this.year,
        })
        .then((res) => {
          if (res.data.response.length !== 0) {
            this.data_payments = res.data.response;
            this.isData = true;
          } else {
            this.isData = false;
          }
        });
    },
    downloadPaymentList() {
      this.$axios
        .post(this.api + "/downloadpayment", {
          payment: this.data_payments,
          month: this.month_name[this.month - 1].name,
          year: this.year + 543,
        })
        .then(() => {});
    },
  },
};
</script>

